import { render } from "./Report Settings.vue?vue&type=template&id=66902674&scoped=true"
import script from "./Report Settings.vue?vue&type=script&lang=js"
export * from "./Report Settings.vue?vue&type=script&lang=js"

import exportComponent from "/Users/erik/IdeaProjects/reportx/client/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66902674"]])

export default __exports__